__turbopack_context__.v({
  "selectStoreMessage": "SelectStoreMessage-module-scss-module__aUWmSa__selectStoreMessage",
  "selectStoreMessageDisabled": "SelectStoreMessage-module-scss-module__aUWmSa__selectStoreMessageDisabled",
  "storeNameButton": "SelectStoreMessage-module-scss-module__aUWmSa__storeNameButton",
});
